const webNewDataes = {
    firstModuleDataes:[
        {
        iconImg:[{ url: require('./images/img/icon_work.png') }],
        desc:['积累工作经验','便于面试就业']
        },{
        iconImg:[{ url: require('./images/img/icon_lichen.png') }]
        ,desc:['体验工作流程','适应职场节奏']
        },{
        iconImg:[{ url: require('./images/img/icon_rail.png') }]
        ,desc:['转换菜鸟角色','真实开发经历']
        },{ 
        iconImg:[{ url: require('./images/img/icon_loophole.png') }]
        ,desc:['发现知识漏洞','弥补经验不足']
        },{ 
        iconImg:[{ url: require('./images/img/icon_communicate.png') }]
        ,desc:['锻炼沟通表达','提高合作能力']
        }
    ],
    secondModuleDataes:[
        [
        //     {
        //     id:1,
        //     title: 'Perfcet Photo & Studio',
        //     desc: '自主创意的摄影作品工作室网站，使用 jQuery + CSS3 + flipping + slick + bootstrap + animate，封装图像切割动效 JavaScript 动效库，实现丰富的图片特效。',
        //     subTit: '深圳-40期程同学组',
        //     img:[{ url: require('./images/img/img_works01.jpg') }],
        //     videoUrl: require('./images/video/01.mp4'),
        //     routerUrl:'http://stu-projects-web.itheima.net/shenzhen/photo-studio/?webzly$jingjiaczpz-PC-1'
        // },
        {
            id:2,
            title: '飘视觉',
            desc: '参考《飘视觉》官网，使用 jQuery + CSS3 + pincolor + swiper，实现专业级动画交互效果，基本全站还原了飘视觉官网全景。',
            subTit: '广州-27期三组',
            img:[{ url: require('./images/img/img_works02.jpg') }],
            videoUrl:require('./images/video/02.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/piao/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:3,
            title: 'UEMO',
            desc: '提供企业网站定制服务解决方案，为企业轻松快速定制官方网站。使用 jQuery + CSS3 + mplayer 实现大量商业级动画效果，尤其动画的设计既专业又炫酷，封装 common JavaScript 工具库。',
            subTit: '广州-11期李同学组',
            img:[{ url: require('./images/img/img_works03.jpg') }],
            videoUrl:require('./images/video/03.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/uemo/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:4,
            title: '唯一视觉婚纱摄影',
            desc: '参考《唯一视觉婚纱摄影》官网，使用 jQuery + CSS3 + animate，动画效果浪漫典雅，充分烘托出新婚的快乐与幸福，小组成员还封装了瀑布流和轮播图组件库。',
            subTit: '西安-7期张同学组',
            img:[{ url: require('./images/img/img_works04.jpg') }],
            videoUrl:require('./images/video/04.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/beijing/weiyishijue/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:5,
            title: '轩辕剑龙舞云山',
            desc: '参考网易游戏《轩辕剑龙舞云山》手游官网，使用 jQuery + CSS3，封装 common JavaScript 工具库，应用 normalize 实现 CSS reset，基本还原了首页全景，动画交互效果精致。',
            subTit: '深圳-38期范同学组',
            img:[{ url: require('./images/img/img_works05.jpg') }],
            videoUrl:require('./images/video/05.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/shenzhen/xueyuanjian/?webzly$jingjiaczpz-PC-1'
        },{
            id:6,
            title: '光·遇',
            desc: '参考网易游戏《光·遇》官网，使用 jQuery + CSS3 + bootstrap + animation，封装 common JavaScript 工具库和 CSS 效果库。',
            subTit: '深圳-38期肖同学组',
            img:[{ url: require('./images/img/img_works06.jpg') }],
            videoUrl:require('./images/video/06.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/shenzhen/guangyu/index/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:7,
            title: '阴阳师：百闻牌',
            desc: '参考网易游戏《阴阳师：百闻牌》手游官网，使用 jQuery + CSS3，封装 Alert Box 及 Top Bar 工具库。',
            subTit: '深圳-38期汪同学组',
            img:[{ url: require('./images/img/img_works07.jpg') }],
            videoUrl:require('./images/video/07.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/shenzhen/baiwenpai/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:8,
            title: '战意',
            desc: '参考网易游戏《战意》官网，使用 jQuery + CSS3 + swiper，封装 topnavCommon JavaScript 工具库，基本全站还原了战意官网全景',
            subTit: '广州-27期二组',
            img:[{ url: require('./images/img/img_works08.jpg') }],
            videoUrl:require('./images/video/08.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/zhanyi/index/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:17,
            title: '优必选官网',
            desc: '参考《优必选官网》官网，使用 jQuery + CSS3 + animate，实现了商业级动画效果，并根据业务封装了星战、地图、服务、店铺等多个 JavaScript 业务库。',
            subTit: '西安-7期高同学组',
            img:[{ url: require('./images/img/img_works17.jpg') }],
            videoUrl:require('./images/video/17.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/beijing/ubtrobot/?webzly$jingjiaczpz-PC-1'
        }],
        [{
            id:9,
            title: 'AWA 官网',
            desc: '参考《AWA 4.0》官网，使用 jQuery + CSS3 + html5shiv + swiper，实现响应式交互菜单动效，封装 shop JavaScript 工具库专门处理商品信息。',
            subTit: '广州-27期六组',
            img:[{ url: require('./images/img/img_works09.jpg') }],
            videoUrl:require('./images/video/09.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/awa/pages/?webzly$jingjiaczpz-PC-1'
        },
        // {
        //     id:10,
        //     title: '阴阳师',
        //     desc: '参考网易游戏《阴阳师》官网，使用 jQuery + CSS3 + swiper + SuperSlide，封装图片动效组件库，封装 common JavaScript 工具库。',
        //     subTit: '广州-25期张同学组',
        //     img:[{ url: require('./images/img/img_works10.jpg') }],
        //     videoUrl:require('./images/video/10.mp4'),
        //     routerUrl:'http://stu-projects-web.itheima.net/guangzhou/yinyangshi/pages/?webzly$jingjiaczpz-PC-1'
        // },
        {
            id:11,
            title: '美食网',
            desc: '美食网，吃天下。使用 jQuery + CSS3 + flex + SuperSlide + 3d-tv，实现大量专业级动画效果，并集成字体图标及百度地图 API。',
            subTit: '广州-23期李同学组',
            img:[{ url: require('./images/img/img_works11.jpg') }],
            videoUrl:require('./images/video/11.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/meishiwang/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:12,
            title: '方舟生存天下',
            desc: '参考网易游戏《方舟生存天下》官网，使用 jQuery + CSS3 + posterSwing + canvas-nest + scrollreveal，独立研发并封装视频播放方案：全屏 + 自动播放 + 轮播。',
            subTit: '广州-23期王同学组',
            img:[{ url: require('./images/img/img_works12.jpg') }],
            videoUrl:require('./images/video/12.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/fangzhou/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:13,
            title: '天下 3',
            desc: '参考网易游戏《天下 3》官网，使用原生的 JavaScript、HTML5 和 CSS3，重点实现人物和场景动画效果，封装 common CSS 动效库',
            subTit: '广州-11期薛同学组',
            img:[{ url: require('./images/img/img_works13.jpg') }],
            videoUrl:require('./images/video/13.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/tianxia3/?webzly$jingjiaczpz-PC-1'
        },{
            id:14,
            title: '蒙娜丽莎婚纱摄影',
            desc: '参照《蒙娜丽莎》婚纱官网，使用 jQuery + CSS3 + Bootstrap + animate + mplayer，实现了丰富的酷炫的动画效果，封装 common JavaScript 工具库。',
            subTit: '广州-11期张同学组',
            img:[{ url: require('./images/img/img_works14.jpg') }],
            videoUrl:require('./images/video/14.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/guangzhou/mengnalisa/index/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:15,
            title: '行行摄色',
            desc: '参考《行行摄色》官网，使用 jQuery + CSS3 + easying + move-line + bundle + animatie，实现了炫酷的 3D 交互式动效，同时还封装 tools JavaScript 工具库，并独立研发了风景照片特效。',
            subTit: '西安-7期高同学组',
            img:[{ url: require('./images/img/img_works15.jpg') }],
            videoUrl:require('./images/video/15.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/beijing/xingxingshese/?webzly$jingjiaczpz-PC-1'
        },
        {
            id:16,
            title: '哇噻网',
            desc: '参考《哇噻网》官网，使用 jQuery + CSS3 + animate，实现了丰富精致的动画效果，小资购物的情调展现的淋漓尽致，同时还封装 common JavaScript 工具库。',
            subTit: '西安-7期马同学组',
            img:[{ url: require('./images/img/img_works16.jpg') }],
            videoUrl:require('./images/video/16.mp4'),
            routerUrl:'http://stu-projects-web.itheima.net/beijing/wasai/?webzly$jingjiaczpz-PC-1'
        }]
        // ,
        // [{
        //     id:17,
        //     title: '优必选官网',
        //     desc: '参考《优必选官网》官网，使用 jQuery + CSS3 + animate，实现了商业级动画效果，并根据业务封装了星战、地图、服务、店铺等多个 JavaScript 业务库。',
        //     subTit: '西安-7期高同学组',
        //     img:[{ url: require('./images/img/img_works17.jpg') }],
        //     videoUrl:require('./images/video/17.mp4'),
        //     routerUrl:'http://stu-projects-web.itheima.net/beijing/ubtrobot/?webzly$jingjiaczpz-PC-1'
        // }]
    ],
    thirdModuleDataes:{
        title: '率先引入TS+React Hook ，解锁React开发者必备技术',
        subTit: 'React17 + React Hook + TypeScript ：大型React 项目质量保证的代名词',
        items:[
            {
                title: 'React基础',
                desc: 'SX | 组件系统 | 虚拟 DOM | 生命周期 | 无状态组件 | 有状态组件 | ref | class | 组件通信 | create-react-app | 路由 | 插值 | state'  
            },
            {
                title: 'Redux',
                desc: '状态管理流程 | action | dispatch | store | reducer | redux-thunk 中间件 | combineReducers | react-redux | 开发调试工具 | 点餐案例'  
            },
            {
                title: 'Hooks',
                desc: 'useState | useEffect | useRef | useContext | useEffect高级用法 | 放大镜案例 | 购物车案例'  
            },
            {
                title: 'TypeScript',
                desc: '基础类型 | 联合类型 | 字面量类型 | 类型推断 | 类型断言 | 泛型 | 类型声明 | ts结合hooks | ts结合redux | ts结合路由 | 点餐案例重构'  
            },
        ],
        terminalItems:[
            {
                imgUrl: require('./images/img/img_pc.jpg'),
                url: '/',
                title: '极客园项目 - PC端',
                desc:'资讯类自媒体管理端，涵盖了后台管理系统的核心业务，基于react技术栈，实现了登录功能，首页展示，文章管理与发布，图片上传等功能，让学员熟练掌握react核心技术栈的开发项目的能力。',
                bgIconUrl: ''
            },
            {
                imgUrl: require('./images/img/img_app.jpg'),
                url: '/',
                title: '极客园项目 - 手机端',
                desc:'新闻资讯类客户端，包括首页文章列表上拉加载与刷新，频道管理，本地线上频道管理等。整个项目基于typescript开发，让学员熟练掌握当前最流行的typescript + react技术栈开发项目的能力。',
                bgIconUrl: ''
            },
        ]
    },
    fourthModuleDataes:{
        title:'Vue趋势技术 全场景使用',
        subTit: 'V3.0 性能优化近50% 大小厂都在使用，面试常考，引领新的技术浪潮',
        mainLeftData: {
            title: 'Vue 3.0 性能提升近50% , 为什么这么强？',
            items: [
                '1、Tree shaking 优化核心库，代码体积更小 ',
                '2、Fragment 代码片段支持，减少非必要标签 ',
                '3、HoistStatic 静态提升，提高渲染性能 ',
                '4、PatchFlag 动态标记，提高vdom的diff性能' ,
                '5、CacheHandler 事件函数缓存，避免函数重复生成 ',
                '6、Proxy 实现响应式数据，代码执行效率高 ',
                '7、源码使用TS编写，更好的类型推导 ',
                '8、Composition API，解决逻辑复用问题 ',
                '9、CreateRenderer 自定义渲染器，支持跨平台渲染 ',
                '10、Teleport Suspense 高阶内置组件，让代码更合理 ',
                '11、SFC支持状态驱动的CSS变量，修改样式更便捷 ',
                '12、配套@vueuse/core Hook库，提供开发常用逻辑，进而提升效率',
            ]
        },
        mainRitData: {
            title: 'Vue3.0新特性，搭配最佳应用场景，带你快速掌握3.0精髓！',
            items: [
                {iconImg: require('./images/img/icon_01@2x.png'), desc: '首页组件数据懒加载'},
                {iconImg: require('./images/img/icon_02@2x.png'), desc: '商品列表无限加载功能'},
                {iconImg: require('./images/img/icon_03@2x.png'), desc: '面板组件骨架屏效果'},
                {iconImg: require('./images/img/icon_04@2x.png'), desc: '商品详情预览图片实现'},
                {iconImg: require('./images/img/icon_05@2x.png'), desc: '小兔鲜UI分页组件'},
                {iconImg: require('./images/img/icon_06@2x.png'), desc: '商品详情SKU组件'},
                {iconImg: require('./images/img/icon_07@2x.png'), desc: '小兔鲜UI对话框组件'},
                {iconImg: require('./images/img/icon_08@2x.png'), desc: '订单详情物流查询功能'},
                {iconImg: require('./images/img/icon_09@2x.png'), desc: '订单列表状态筛选实现'},
                {iconImg: '', desc: '… …'},
            ]
        },
    },
    fifthModuleDataes:{
        title: '全面覆盖React Native开发各个环节，带你走进高阶前端的世界',
        subTit: '全技术覆盖+企业工作场景全流程学习，让你掌握技术同时拥有一次真正的开发历程',
        items: [
            '01 需求分析','02 功能划分','03 架构设计','04 工具应用','05 技术分解','06 核心功能实现','07 高阶功能开发','08 bug技巧解决','09 项目优化','10 打包上线'
        ]
    }, 
    sixthModuleDataes:{
        title: '真实的业务图表设计，锻造Echarts数据可视化深度定制项目课',
        subTit: '带你通过Echarts基础组件，实现设计师万千变化的设计需求',
        items:['如何把这些平平无奇的图形变成设计师想要的样子？', 'Echarts深度定制项目课程，带你快速实现酷炫的效果']
    },
    seventhModuleDataes:{
        title: '30+解决方案，快速搞定工作难题',
        subTit: '相同的工作场景，开发不必从零开始，方案拿来即用，让你成为团队问题解决最高效的人',
        items:[
            {title: 'Vue-element-admin 后台前端解决方案', desc: '是一个后台前端解决方案，它基于 vue 和 element-ui实现，它使用了最新的前端技术栈。'},
            {title: 'Vuex分模块状态共享方案', desc: '使用Vuex进行拆分模块给予命名空间，维护状态数据，修改数据函数，获取数据函数。'},
            {title: 'RBAC权限设计方案及应用', desc: '采用基于角色的权限控制方案，结合动态路由及vuejs中mixin方案的集成，和token鉴权结合的权限分配。'},
            {title: '试题全流程解决方案', desc: '从试题录入，试题预览，审核试题，加入精选，分配题组，完整的试题业务流程。'},
            {title: 'Vuex分模块状态共享及持久化方案', desc: '使用Vuex进行拆分模块命名空间，并存储token和用户信息的共享及持久化方案。'},
            {title: 'Token鉴定及换取token解决方案', desc: '移动app端持久化token应用方案 Token时效性两个小时到期，使用refresh_token进行换取最新token并重发失效请求。'},
            {title: '基于Vant组件库移动端上手势加载方案', desc: '使用下拉组件和列表组件实现上拉加载，下拉刷新等移动手势的核心业务多组件实例下的数据存储结构及组件间交互处理。'},
            {title: 'Keep-Alive组件缓存解决方案', desc: '阅读类App提升前端内容可用性，使用Keep-alive动态管理缓存类组件。'},
            {title: 'WebSocket即时通讯实现客服通信解决方案', desc: '采用ws协议实现点对点通信的客服应用 在web端实现实时聊天的业务需求。'},
            {title: '请求器拦截应用及异步编程方案', desc: '采用axios请求工具进行请求，请求拦截器进行token统一注入 响应拦截器进行数据解构处理及异常处理 Async/await统一的异步编程方案。'},
            {title: '大屏幕适配解决方案', desc: '利用媒体查询检测屏幕的尺寸来应用不同的 CSS 样式，调整页面的布局情况，同时配合 REM 长度单位来根据屏幕的尺寸动态更新网页元素的大小。'},
            {title: '数据可视化解决方案', desc: '采用Echarts开源数据可视化库，根据产品需求高度自定义可视化图表，直观的表现海量数据。'},
            {title: '实时数据推送解决方案', desc: '通过（长）轮循方式实时更新可视化图表数据。'},
            {title: 'JavaScript开发手机App', desc: 'Facebook 出品的React Native 技术，可以创建 Android 和 iOS 的原生应用功能。React Native 将原生开发的最佳部分与 React 相结合， 致力于成为构建用户界面的顶尖 JavaScript 框架。'},
            {title: 'Nuxt.js框架SSR解决方案', desc: '使用Nuxt.js框架实现前后端分类项目满足服务端渲染需求。'},
            {title: '高德LBS酒店定位导航解决方案', desc: '基于高德提高的地理定位商业服务获取当前定位和周边酒店以及导航功能。'},
            {title: '组件递归跟帖解决方案', desc: '在评价业务，跟帖业务，数据一般都是树状结构，使用组件递归完成相同结构内容渲染。'},
            {title: '二维码付款解决方案', desc: '在支付环节使用前端技术生成二维码完成支付二维码生成。'},
            {title: 'Vue3.0中大型项目构建', desc: '使用vue-cli构建vue3.0项目，依赖vue-router4.x,vuex4.x配套技术完成前端路由实现和状态管理。'},
            {title: '组合API加载性能优化', desc: '使用 @vueuse/core提供的 useIntersectionObserver 监听进入可视区，实现组件数据懒加载，实现图片懒加载；使用 skeleton 实现加载等待；使用路由懒加载分割资源文件。'},
            {title: '商品SKU前端算法', desc: '前端展示商品使用 power-set 幂集算法，后台录入商品使用 cartesian 笛卡尔积算法，完成对不可选商品规格的筛选。'},
            {title: '封装UI组件库', desc: '根据小兔鲜前台设计，独立封装对应的通用组件，整合成为小兔鲜UI风格的组件库。'},
            {title: '本地线上融合购物车', desc: '使用H5的localStorage实现本地购物车，使用后台的接口服务实现线上购物车，登录后进行本地和线上购物车合并。'},
            {title: 'Vuex分模块状态共享及持久化方案', desc: '使用Vuex进行拆分模块命名空间，并存储token和用户信息的共享及持久化方案。'},
            {title: 'Token失效的两种鉴定方式同时方案', desc: '使用token主动介入鉴定的方式来提前预知token的时效性 使用token被动通知的方式弥补出现时间盲区时的token失效问题。'},
            {title: 'Element中Tree型组件等树形业务的应用方案', desc: '常规树形数据结构的生成和递归算法的整体思路 树形组件统一抽提的剥离及应用方式 表单自定义业务校验类的深度应用。'},
            {title: 'RBAC权限设计方案及应用', desc: '采用基于角色的权限控制方案 设计“权限点”，分配“权限点”，根据“权限点”动态分配当前用户角色的路由及按钮级权限 结合动态路由及vuejs中mixin方案的集成，和token鉴权结合的权限分配。'},
            {title: '通用上传组件封装及第三方上传', desc: '应用服务器和文件服务器分离 通用的上传组件封装，集展示，设置，删除，更新于一身。'},
            {title: '请求器拦截应用及异步编程方案', desc: '采用axios请求工具进行请求，请求拦截器进行token统一注入 响应拦截器进行数据解构处理及异常处理 Async/await统一的异步编程方案。'}
        ]
    }
}
export default webNewDataes